/**
 * Forcing $nextTick for issues with Safari.
 *
 * @link https://github.com/alpinejs/alpine/discussions/2855
 */

'use strict';

const doubleRequestAnimationFrame = ( callback ) => {
	requestAnimationFrame( () => {
		requestAnimationFrame( callback );
	});
};

function $forceNextTick( callback = () => {}) {
	if ( callback && 'function' === typeof callback ) {
		doubleRequestAnimationFrame( callback );
	} else {
		return new Promise( resolve => {
			doubleRequestAnimationFrame( resolve );
		});
	}
}

Alpine.magic( 'forceNextTick', () => $forceNextTick );
